/**
 * 自动计算是否需要横屏
 */
export function autoCalcRotate() {
    var innerWidth = window.innerWidth, innerHeight = window.innerHeight;
    return innerWidth < innerHeight;
}
export function setRotateStyle(inRotate) {
    var innerWidth = window.innerWidth, innerHeight = window.innerHeight;
    if (inRotate) {
        var width = innerHeight % 2 > 0 ? innerHeight + 1 : innerHeight;
        var height = innerWidth % 2 > 0 ? innerWidth + 1 : innerWidth;
        document.body.style.top = "".concat((width - height) / 2, "px");
        document.body.style.left = "".concat((height - width) / 2, "px");
        document.body.style.width = "".concat(width, "px");
        document.body.style.height = "".concat(height, "px");
        document.body.dataset.rotate = "1";
        return { width: width, height: height, inRotate: true };
    }
    else {
        var width = innerWidth;
        var height = innerHeight;
        document.body.style.top = "";
        document.body.style.left = "";
        document.body.style.width = "".concat(width, "px");
        document.body.style.height = "".concat(height, "px");
        document.body.dataset.rotate = "0";
        return { width: width, height: height, inRotate: false };
    }
}
export function register(handler) {
    handler();
    window.addEventListener("resize", handler);
    return handler;
}
export function unregister(handler) {
    window.removeEventListener("resize", handler);
}
